export enum RemoteFirstVisitCase {
  checkInCount = 'checkInCount',
  collapsedChallengeInfoIndividual = 'collapsedChallengeInfoIndividual',
  collapsedChallengeInfoGroup = 'collapsedChallengeInfoGroup',
  completedReflection = 'completedReflection',
  dismissedAccountCreationModal = 'dismissedAccountCreationModal',
  discover = 'explore',
  firstActionAdded = 'firstActionAdded',
  firstQuestAdded = 'firstQuestAdded',
  firstTimeAppVisit = 'firstTimeAppVisit',
  lastModalLaunch = 'lastModalLaunch',
  onboarding = 'onboarding',
  progress = 'progress',
  purposefulVisits = 'purposefulVisits',
  resourcefulVisits = 'resourcefulVisits',
  shownCrossPromotionModal = 'shownCrossPromotionModal',
  shownExpandedLiveSupport = 'shownExpandedLiveSupport',
  shownNotificationsModal = 'shownNotificationsModal',
  shownPurposefulFeedbackModal = 'shownPurposefulFeedbackModal',
  shownResourcefulFeedbackModal = 'shownResourcefulFeedbackModal',
  initialDailyChallenge = 'initialDailyChallenge',
  today = 'today',
  webMigrated = 'webMigrated',
}
